import React from 'react'
import { ArrowRightAlt } from '@mui/icons-material'

import useStyles from './styles'

interface Props {
    label?: string;
    classes?: string;
    leftInputs?: React.ReactNode;
    rightInputs?: React.ReactNode;
}

/**
 * 
 * @param label String value with label to show on top of inputs or fields
 * @param classes String value with classes to use on box container
 * @params lefInputs React element optional to show on left side 
 * @params rightInputs React element optional to show on right side. If fill this prop, then, show a right arrow
 * @returns JSX Element
 */
export const GenericForm = ({ label, classes, rightInputs, leftInputs }: Props) => {
    const classeStyle = useStyles()

    return (
        <div className={classes}>
            {(label && label.length > 0) && <label className={`mb-0 ${classeStyle.instructionListLabel}`}>{label}</label>}
            <div style={{ display: 'flex', alignItems: 'center' }}>
                {leftInputs}

                {rightInputs && (
                    <div
                        className={classeStyle.row}
                        style={{marginTop: '-6px'}}
                    >
                        <ArrowRightAlt />
                        {rightInputs}

                    </div>
                )}
            </div>
        </div>
    )
}
